export const PRICE_PARITY_STARTING_AT_TEXT_KEY =
  'PRICE_PARITY_STARTING_AT_TEXT';
export const SHOW_ADD_ONS_KEY = 'SHOW_ADD_ONS';
export const OLLIE_APP_FOOTER_DOWNLOAD_BUTTONS_KEY =
  'OLLIE_APP_FOOTER_DOWNLOAD_BUTTONS';
export const CAMPAIGN_TYPE = 'ab';
export const HIDE_BAKED_ONLY_MEMBER_EXPERIENCE =
  'HIDE_BAKED_ONLY_MEMBER_EXPERIENCE';
export const SHOW_HALF_FRESH_MEMBER_EXPERIENCE_EDIT_FLOW =
  'SHOW_HALF_FRESH_MEMBER_EXPERIENCE_EDIT_FLOW';
export const SHOW_HALF_FRESH_MEMBER_EXPERIENCE_ADD_PUP_AND_REACTIVATION_FLOWS =
  'SHOW_HALF_FRESH_MEMBER_EXPERIENCE_ADD_PUP_AND_REACTIVATION_FLOWS';
export const SHOW_QUICK_ADD_EXTRAS_SECTION = 'SHOW_QUICK_ADD_EXTRAS_SECTION';
export const flagshipData = {
  initialFlags: [
    {
      campaignType: 'toogle',
      key: 'SHOW_ADD_ONS',
      variationId: 'caqtvu2cn57g16mri14g',
      variationName: 'Show Add ons',
    },
    {
      campaignType: 'ab',
      key: 'backgroundColor',
      variationId: 'cao3sane0j9g8tkq16k0',
      variationName: 'Background Color',
    },
  ],
};
export const SHOW_LAMB = 'SHOW_LAMB';
export const SHOW_CHICKEN = 'SHOW_CHICKEN';
export const SHOW_PORTION_SECTION_WEB = 'SHOW_PORTION_SECTION_WEB';
export const SHOW_LAZYLOAD_HOMEPAGE = 'SHOW_LAZYLOAD_HOMEPAGE';
export const HIDE_VAN_LEEUWEN = 'HIDE_VAN_LEEUWEN';
export const HIDE_ALLERGIES_WEB = 'HIDE_ALLERGIES_WEB';
export const SHOW_PAUSE_SUBSCRIPTION_BUTTON = 'SHOW_PAUSE_SUBSCRIPTION_BUTTON';
export const ONBOARDING_FLOW_UI = 'ONBOARDING_FLOW_UI';
export const SHOW_SKIP_QUICK_ACTION = 'SHOW_SKIP_QUICK_ACTION';
export const SHOW_HIGHER_DISCOUNT_APP_CTA = 'SHOW_HIGHER_DISCOUNT_APP_CTA';
export const TREATS_FOR_LIFE = 'TREATS_FOR_LIFE';
export const HIDE_MIXED = 'HIDE_MIXED';
export const SHOW_100_DOLLAR_LOTTERY_APP_CTA =
  'SHOW_100_DOLLAR_LOTTERY_APP_CTA';
export const HIDE_GLADLY_WIDGET = 'HIDE_GLADLY_WIDGET';
export const CHECKOUT_NEXT_BOX_PRICE = 'CHECKOUT_NEXT_BOX_PRICE';
export const CHECKOUT_GWP_CALLOUT = 'CHECKOUT_GWP_CALLOUT';
export const BAKED_RECALL_ROLLBACK = 'BAKED_RECALL_ROLLBACK';
export const SHOW_REACTIVATION_PROMO = 'SHOW_REACTIVATION_PROMO';
export const SHOW_GIFT_STEP = 'SHOW_GIFT_STEP';
export const SHOW_GIFT_CHECKOUT_EXTENSION = 'SHOW_GIFT_CHECKOUT_EXTENSION';
export const SHOW_QUIZ_ABANDONER_MENU = 'SHOW_QUIZ_ABANDONER_MENU';
export const ONBOARDING_PUP_BREED_STEP = 'ONBOARDING_PUP_BREED_STEP';
export const PROMO_CODE_CONTENT_KEY = 'PROMO_CODE';
export const SKIP_GWP_CODES = 'SKIP_GWP_CODES';
export const PET_MX_V4_ENDPOINT_WEB = 'PET_MX_V4_ENDPOINT_WEB';
export const SHOW_CHECKOUT_BANNERS = 'SHOW_CHECKOUT_BANNERS';
export const CHECKOUT_VALUE_PROPS_LOCATION = 'CHECKOUT_VALUE_PROPS_LOCATION';
export const CHECKOUT_CX_CTAS = 'CHECKOUT_CX_CTAS';
export const STARTER_CRUNCH_VS_LOADING = 'STARTER_CRUNCH_VS_LOADING';
export const SHOW_NEXT_BOX_AND_RECOMMENDED_FIRST =
  'SHOW_NEXT_BOX_AND_RECOMMENDED_FIRST';
